import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  getExecutiveClientTeamOptions,
  getTeamPipelineOptions,
} from 'client/@tanstack/react-query.gen';

export const editUserPipelineSearchSchema = z.object({
  from: z.string().optional().catch(undefined),
});

export const Route = createFileRoute(
  '/_private/_route/users/$userId/pipelines/$pipelineId/edit',
)({
  beforeLoad: async ({ context, params }) => {
    const { queryClient } = context;
    const executiveTeam = await queryClient.ensureQueryData(
      getExecutiveClientTeamOptions({
        path: {
          person_uuid: params.userId,
        },
      }),
    );
    await queryClient.ensureQueryData(
      getTeamPipelineOptions({
        path: {
          pipeline_uuid: params.pipelineId,
          team_uuid: executiveTeam.team_slug,
        },
      }),
    );
  },
  validateSearch: editUserPipelineSearchSchema,
});
